import Link from '@/components/ui/Link';
import type { TextLinkBlock as TextLinkBlockProps } from '@/@types/content';

const TextLinkBlock: React.FC<TextLinkBlockProps> = ({ link }) => (
  <Link propertyName="Link" {...link} variant="text-link-1" className="py-[10px] text-gray-dark" />
);

export default TextLinkBlock;
